import { j as s } from "../../jsx-runtime-B6kdoens.js";
import { forwardRef as p, useMemo as i, useState as C, useRef as y, useCallback as B, useEffect as k } from "react";
import { c as l } from "../../index-CROKJrb5.js";
import { c as w, f as P } from "../../create-component-CBAeEoQ6.js";
import { M as E } from "../../motion-jk0ivqSc.js";
import { Typography as I } from "../Typography/index.js";
import { a as g } from "../../as-num-DQjLjHSI.js";
import { LoadingIcon as M } from "../Icon/icons/LoadingIcon/index.js";
import { m as T } from "../../motion-minimal-Crg_qVxv.js";
class R extends Error {
}
class h extends R {
}
const z = l({
  base: "cur-relative cur-overflow-hidden",
  variants: {
    size: {
      sm: "cur-min-h-[2px]",
      md: "cur-min-h-[4px]",
      lg: "cur-min-h-[8px]"
    }
  }
}), U = l({
  base: "cur-w-full cur-absolute cur-left-0 cur-bottom-0",
  variants: {
    size: {
      sm: "cur-h-[2px]",
      md: "cur-h-1",
      lg: "cur-h-2"
    }
  }
}), j = ({
  className: r,
  size: t
}) => /* @__PURE__ */ s.jsx("div", { className: U({ className: r, size: t }) }), b = ({ children: r, size: t }) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  r,
  /* @__PURE__ */ s.jsx(j, { className: "cur-bg-surface-brand-accent", size: t })
] }), $ = l({
  base: "cur-absolute cur-top-0 cur-z-10 cur-h-full cur-w-full cur-origin-left cur-transition-all",
  variants: {
    done: {
      true: "cur-duration-150",
      false: "cur-duration-1000"
    }
  }
}), v = p(
  ({ children: r, className: t, max: a = 1, size: e, track: o = !0, value: n, ...c }, d) => {
    const x = i(() => n && g(n) || 0, [n]), f = i(() => g(a), [a]), m = n === void 0, u = m ? 33.33333 : Math.round(x / f * 100), N = x >= f;
    return /* @__PURE__ */ s.jsx(E, { children: /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: z({ className: t, size: e }),
        ref: d,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": f,
        "aria-valuenow": u,
        ...c,
        children: [
          m ? /* @__PURE__ */ s.jsx(
            T.div,
            {
              className: "cur-absolute cur-top-0 cur-z-10 cur-h-full cur-w-full cur-origin-left",
              animate: {
                transition: {
                  duration: 2,
                  repeat: 1 / 0,
                  // repeatType: 'reverse',
                  times: [0, 0.5, 2]
                  // type: 'spring',
                },
                x: ["0%", "100%"],
                scaleX: ["0%", `${u}%`, "0%"]
              },
              children: /* @__PURE__ */ s.jsx(b, { size: e, children: r && typeof r == "function" ? r(m ? null : u) : null })
            }
          ) : /* @__PURE__ */ s.jsx(
            "div",
            {
              className: $({ done: N }),
              style: {
                width: `${u}%`
              },
              children: /* @__PURE__ */ s.jsx(b, { size: e, children: r && typeof r == "function" ? r(m ? null : u) : null })
            }
          ),
          o && /* @__PURE__ */ s.jsx(
            j,
            {
              size: e,
              className: "cur-z-0 cur-bg-surface-warning"
            }
          )
        ]
      }
    ) });
  }
), A = l({
  base: "cur-flex cur-gap-2 cur-items-center",
  variants: {
    align: {
      left: null,
      right: "cur-flex-row-reverse"
    }
  }
}), F = p(({ align: r, className: t, max: a = 1, value: e = 0, ...o }, n) => {
  const c = i(() => e && g(e) || 0, [e]), d = i(() => g(a), [a]);
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: A({
        align: r,
        className: t
      }),
      ref: n,
      children: [
        /* @__PURE__ */ s.jsxs(
          I,
          {
            className: "cur-text-primary",
            size: "meta",
            weight: "bold",
            "aria-hidden": !0,
            children: [
              Math.round(c / d * 100),
              "%"
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          v,
          {
            size: "sm",
            value: e || 0,
            className: "cur-grow",
            max: a,
            ...o
          }
        )
      ]
    }
  );
}), L = l({
  base: "cur-animate-spin",
  variants: {
    state: {
      highlight: "cur-text-border-brand",
      critical: "cur-text-border-error",
      success: "cur-text-border-success",
      dark: "cur-text-border-secondary"
    },
    stateNotPassed: {
      true: "cur-text-white"
    }
  }
}), O = p(({ className: r, size: t, state: a, ...e }, o) => {
  const n = !a;
  return /* @__PURE__ */ s.jsx(
    M,
    {
      ...e,
      size: t,
      className: L({ className: r, state: a, stateNotPassed: n }),
      role: "progressbar",
      ref: o
    }
  );
}), S = w(
  "Progress",
  P(
    ({ max: r, size: t = "md", progressType: a = "bar", value: e, ...o }, n) => {
      switch (a) {
        case "circle":
          if (e || r)
            throw new h(
              'Cannot use the <Progress /> component with a progressType of "circle" and a value or max.'
            );
          return /* @__PURE__ */ s.jsx(O, { size: t, ...o, ref: n });
        case "percentage":
          if (e === void 0)
            throw new h(
              'Cannot use the <Progress /> component with a progressType of "percentage" and a value of "undefined".'
            );
          return /* @__PURE__ */ s.jsx(F, { max: r, value: e, ...o, ref: n });
        case "bar":
        default:
          return /* @__PURE__ */ s.jsx(
            v,
            {
              max: r,
              size: t,
              value: e,
              ...o,
              ref: n
            }
          );
      }
    }
  )
), V = (r) => {
  const [t, a] = C(1), e = y(null), o = B(() => {
    e.current && (clearInterval(e.current), e.current = null);
  }, []);
  k(() => (o(), r || (e.current = setInterval(() => {
    a((c) => c + 1);
  }, 1e3)), o), [o, r]);
  const n = i(() => (100 - 10 * (10 / t)) / 100, [t]);
  return r ? 1 : n;
}, Y = w(
  "UnknownProgress",
  P(
    ({ done: r = !1, ...t }, a) => {
      const e = V(r);
      return /* @__PURE__ */ s.jsx(S, { ...t, value: e, ref: a });
    }
  )
);
export {
  S as Progress,
  Y as UnknownProgress,
  V as useUnknownProgressValue
};
//# sourceMappingURL=index.js.map
